/* eslint-disable no-param-reassign */

import {useEffect, useState} from "react";

/**
 * @param min the minimum number
 * @param max the maximum number
 * @return a random integer between min (inclusive) and max (inclusive).
 */
export function randInt(min: number, max: number): number {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * @param arr the target array to choose from
 * @return a random element in the array
 */
export function arrayChoice<T>(arr: T[]): T | never {
    const len = arr.length;
    if (len === 0) throw Error('Input array is empty.');
    const idx = randInt(0, len);
    return arr[idx];
}

export function stringIterSearch(
    target: string | undefined, source: string | undefined,
): boolean {
    if (!source) return true;
    if (!target) return false;
    let s = 0;
    for (let t = 0; t < target.length; t += 1) {
        if (target[t] === source[s]) s += 1;
        if (s === source.length) return true;
    }
    return false;
}

const whichDomain = (): number => {
    // return typeof window === 'undefined' ? -1 : window.location.hostname.endsWith("staging.harmonia.illiacsoftware.com") ? 1 : window.location.hostname.endsWith("harmonia.illiacsoftware.com") ? 2 : 0;
    return typeof window === 'undefined' ? -1
        : window.location.hostname.indexOf("staging") !== -1 ? 1
        : (window.location.hostname.endsWith("harmonia.illiacsoftware.com") || window.location.hostname.endsWith("harmonia.cloud")) ? 2 : 0;
}

export const homePageDomain = (): string => {
    const [d, setD] = useState("");
    useEffect(() => {
        switch (whichDomain()) {
            case 0:
                setD("http://localhost:3200/");
                break;
            case 1:
                setD("https://staging.harmonia.illiacsoftware.com/");
                break;
            default:
                setD("https://harmonia.cloud/");
        }
    }, []);
    return d;
}

export const supportDomain = (): string => {
    const [d, setD] = useState("");
    useEffect(() => {
        switch (whichDomain()) {
            case 0:
                setD("http://localhost:3100/");
                break;
            case 1:
                setD("https://support.staging.harmonia.illiacsoftware.com/");
                break;
            default:
                setD("https://support.harmonia.illiacsoftware.com/");
        }
    }, []);
    return d;
}

export const blogDomain = (): string => {
    const [d, setD] = useState("");
    useEffect(() => {
        switch (whichDomain()) {
            case 0:
                setD("http://localhost:3000/");
                break;
            case 1:
                setD("https://blog.staging.harmonia.illiacsoftware.com/");
                break;
            default:
                setD("https://blog.harmonia.illiacsoftware.com/");
        }
    }, []);
    return d;
}

export const videosDomain = (): string => {
    const [d, setD] = useState("");
    useEffect(() => {
        switch (whichDomain()) {
            case 0:
                setD("http://localhost:3300/");
                break;
            case 1:
                setD("https://videos.staging.harmonia.illiacsoftware.com/");
                break;
            default:
                setD("https://videos.harmonia.illiacsoftware.com/");
        }
    }, []);
    return d;
}

export * from './hooks';
